import { Size } from "../../../../services/product";
import styled, { css } from "styled-components";
import { BaseGridContainerProps } from "../../../utils/styles";

interface ProductsWrapProps extends BaseGridContainerProps {
	gridGap?: number;
}

export const GridOneBaseBox = styled.section.withConfig({
	shouldForwardProp: (prop) => !["gridGapd"].includes(prop),
})<ProductsWrapProps>`
	display: grid;
	grid-template-areas: "a a .";
	overflow-x: scroll;
	flex-wrap: nowrap;
	grid-auto-flow: row dense;

	${(props: ProductsWrapProps) => {
		const gap = props.gridGap || 12;
		if (typeof props.gridWidth === "number") {
			return css`
				grid-gap: ${gap}px;
				grid-template-columns: repeat(auto-fill, ${props.gridWidth}px);
			`;
		}
		return css`
			grid-gap: ${gap}px;
			width: ${props.gridWidth};
		`;
	}}

	@supports not (display: grid) {
		display: flex;
		grid-gap: 0;

		& > * {
			${(props: ProductsWrapProps) => {
				return css`
					margin-right: ${props.gridGap}px || "12px";
				`;
			}}
		}
	}
`;
export const SingleScrollContainer = styled(GridOneBaseBox)``;

export const NormalContainer = styled.section.withConfig({
	shouldForwardProp: (prop) => !["gridWidth"].includes(prop),
})<{ gridWidth: number }>`
	position: relative;
	overflow: hidden;
	margin: 0 auto;
	width: ${(props: { gridWidth: number }) => {
		return `${props.gridWidth}px`;
	}};
`;

export const IconArrow = styled.div.withConfig({
	shouldForwardProp: (prop) => !["height", "width"].includes(prop),
})<Size>`
	position: absolute;
	background: #000000;
	opacity: 0.15;
	z-index: 1;
	cursor: pointer;
	top: 50%;

	${(props: Size) => {
		if (props?.height || props.width) {
			const gap = `calc(${props.height || "88px"} / -2)`;
			return css`
				width: ${props.width || "38px"};
				height: ${props.height || "88px"};
				margin-top: ${gap};
			`;
		}

		return css`
			width: 38px;
			margin-top: -44px;
			height: 88px;
		`;
	}}

	&:after {
		display: inline-block;
		content: " ";
		height: 17px;
		width: 17px;
		border-color: #fff;
		border-style: solid;
		border-width: 2px 2px 0 0;
		position: absolute;
		top: 50%;
		margin-top: -9.5px;
		transition: 0.3s;
	}

	&:hover {
		transition: 0.3s;
		opacity: 0.5;
	}
`;

export const LeftIconArrow = styled(IconArrow)`
	left: 0px;
	&:after {
		left: 12px;
		transform: rotate(-135deg);
	}
`;
export const RightsIconArrow = styled(IconArrow)`
	right: 0px;
	border-radius: 4px 0px 0px 4px;
	&:after {
		transform: rotate(45deg);
	}
`;

export const ProductCardWrap = styled.section`
	> a {
		width: 100%;
		height: 100%;
	}
`;
